import * as actionTypes from './EquityTypeActionType';

export const getEquityTypeDropdownRequest = () => ({
    type: actionTypes.GET_EQUITY_TYPE_DROPDOWN_REQUEST,
});

export const getEquityTypeDropdownSuccess = (data) => ({
    type: actionTypes.GET_EQUITY_TYPE_DROPDOWN_SUCCESS,
    payload: data,
});

export const getEquityTypeDropdownFailure = (error) => ({
    type: actionTypes.GET_EQUITY_TYPE_DROPDOWN_FAILURE,
    payload: error,
});
